import z from "zod";
import { LayoutIdScheme, ProductPageId, ProductPageIdScheme } from "./ids";
import { LayoutItemScheme } from "./layoutItem";
import { CatalogOrigin } from "./enums/CatalogOrigin";

export const ALL_PRODUCT_PAGE_ID = "ALL" as ProductPageId;

export const isAllProductPageId = (
  productPageId: ProductPageId | null | undefined,
) => productPageId === ALL_PRODUCT_PAGE_ID;

export const ProductPageDBScheme = z.object({
  id: ProductPageIdScheme,
  name: z.string(),
  items: z.array(LayoutItemScheme),
  layoutId: LayoutIdScheme.optional(),
  origin: z.enum(CatalogOrigin).optional(),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
});

export const RestGetProductPage = ProductPageDBScheme;

export const RestCreateProductPage = ProductPageDBScheme.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
});

export const RestUpdateProductPage = ProductPageDBScheme.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
}).partial();

export type DBProductPage = z.infer<typeof ProductPageDBScheme>;
export type RestProductPage = z.infer<typeof RestGetProductPage>;
export type RestCreateProductPageType = z.infer<typeof RestCreateProductPage>;
export type RestUpdateProductPageType = z.infer<typeof RestUpdateProductPage>;
export type ProductPageItem = z.infer<typeof LayoutItemScheme>;
